import axios from 'axios';

export const academicYearsService = {
  async getAll() {
    const res = await axios.get('/academic-years/active');
    return res.data.data || [];
  },
};
